import { toast } from "react-toastify";
import { throwError } from "../../../utils/errorHandling";
import {  IMutationResponse, IResponse, IStandardResponse } from "../../orders/models/order";
import { apiClient } from "../../../services/yarnFocusClient";
import { ICompany, ICurrency, IDeliver, IDestination, IIncoterm, IOrderType, IPaymentTerm, IProcessType, ISalesperson, IShippingMode, ISupplier, ISupplierTypeLocation, TOrderItem } from "../models/rmm_models";
import { IAccessoryPOrder } from "../../orders/models/accessory";
import { ORDERS_QUERY_KEY } from "../../orders/hooks/useOrders";
import {  IFcdOrder, IYarnPOrder } from "../models/yarn";
import { IPoNotification } from "../../orders/models/notification";
export  enum ERMMEndPoint {
  ORDER_TYPE = "data-provider/ordertype/all",
  SALES_PERSON = "data-provider/salesperson/all",
  CURRENCIES = "data-provider/currencies/all",
  PAYMENT_TERM = "data-provider/payment_term/all",
  COMPANIES = "data-provider/companies/all",
  SUPPLIER = "data-provider/supplier/all?type=acc",
  SUPPLIER_TYPE_LOCATION = "data-provider/suppliertypelocation/all",
  DESTINATION = "data-provider/destination/all",
  DELIVER = "data-provider/deliver/all",
  SHIPPING_MODE = "data-provider/shippingmode/all",
  PROCESS_TYPE = "data-provider/processtype/all",
  INCOTERM = "data-provider/incoterm/all",
  NOTIFICATIONS = "auditlogs/notification_list",
  SET_VIEW_NOTIFICATION = "auditlogs/set_view_notification/",
  TYPED_SUPPLIER = "data-provider/supplier/all?type=",
  TRACKING_LOG="order/log/",
  ORDER_FCD = "order/fcd",

}
export const rawMaterialApi = {
  getOrderType: async (): Promise<IStandardResponse<Array<IOrderType>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IOrderType>>
      >(ERMMEndPoint.ORDER_TYPE);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getSalesPerson: async (): Promise<IStandardResponse<Array<ISalesperson>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ISalesperson>>
      >(ERMMEndPoint.SALES_PERSON);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getCurrencies: async (): Promise<IStandardResponse<Array<ICurrency>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ICurrency>>
      >(ERMMEndPoint.CURRENCIES);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getPaymentTerm: async (): Promise<IStandardResponse<Array<IPaymentTerm>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IPaymentTerm>>
      >(ERMMEndPoint.PAYMENT_TERM);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getCompanies: async (): Promise<IStandardResponse<Array<ICompany>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ICompany>>
      >(ERMMEndPoint.COMPANIES);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getSuppliers: async (): Promise<IStandardResponse<Array<ISupplier>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ISupplier>>
      >(ERMMEndPoint.SUPPLIER);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getTypedSuppliers: async (
    type: string
  ): Promise<IStandardResponse<Array<ISupplier>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ISupplier>>
      >(ERMMEndPoint.TYPED_SUPPLIER + type);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getSuppliersTypeLocation: async (): Promise<
    IStandardResponse<Array<ISupplierTypeLocation>>
  > => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<ISupplierTypeLocation>>
      >(ERMMEndPoint.SUPPLIER_TYPE_LOCATION);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getDestinations: async (): Promise<
    IStandardResponse<Array<IDestination>>
  > => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IDestination>>
      >(ERMMEndPoint.DESTINATION);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getDelivery: async (): Promise<IStandardResponse<Array<IDeliver>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IDeliver>>
      >(ERMMEndPoint.DELIVER);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getShippingMode: async (): Promise<
    IStandardResponse<Array<IShippingMode>>
  > => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IShippingMode>>
      >(ERMMEndPoint.SHIPPING_MODE);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getIncoterms: async (): Promise<IStandardResponse<Array<IIncoterm>>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IIncoterm>>
      >(ERMMEndPoint.INCOTERM);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getAccOrders: async (
    type: TOrderItem,
    page: number = 1,
    limit: number = 10,
    search: Record<string, any>,
    sort: string,
    key: string,
    global_search?: string
  ): Promise<IResponse<IAccessoryPOrder>> => {
    try {
      const { data } = await apiClient.get<IResponse<IAccessoryPOrder>>(
        `${ORDERS_QUERY_KEY}/${type}`,
        {
          params: {
            type,
            page,
            limit,
            search,
            sort,
            key,
            global_search,
          },
        }
      );
      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getYarnOrders: async (
    type: TOrderItem,
    page: number = 1,
    limit: number = 10,
    search: Record<string, any>,
    sort: string,
    key: string,
    global_search?: string
  ): Promise<IResponse<IYarnPOrder>> => {
    try {
      const { data } = await apiClient.get<IResponse<IYarnPOrder>>(
        `${ORDERS_QUERY_KEY}/${type}`,
        {
          params: {
            type,
            page,
            limit,
            search,
            sort,
            key,
            global_search,
          },
        }
      );
      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  getLSPOrders: async (
    type: TOrderItem,
    page: number = 1,
    limit: number = 10,
    search: Record<string, any>,
    sort: string,
    key: string,
    global_search?: string
  ): Promise<IResponse<IYarnPOrder|IAccessoryPOrder>> => {
    try {
      const { data } = await apiClient.get<IResponse<IYarnPOrder|IAccessoryPOrder>>(
        `${ORDERS_QUERY_KEY}/${type}`,
        {
          params: {
            type,
            page,
            limit,
            search,
            sort,
            key,
            global_search,
          },
        }
      );
      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  setViewNotification: async (id: number): Promise<IMutationResponse> => {
    try {
      const { data } = await apiClient.patch<IMutationResponse>(
        ERMMEndPoint.SET_VIEW_NOTIFICATION + id
      );
      return data;
    } catch (error: any) {
      if (Array.isArray(error.message)) {
        error.message.map((item: string) =>
          toast.error(item || "Error on showing notifications")
        );
      } else {
        toast.error(
          error.message.toString() || "Error on showing notification"
        );
      }
      throw new Error(throwError(error));
    }
  },
  getNotificationList: async (
    key: string
  ): Promise<IStandardResponse<IPoNotification[][]>> => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<IPoNotification[][]>
      >(ERMMEndPoint.NOTIFICATIONS + "?key=" + key);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },
  orderfetchLogFile:async(orderCode: string):Promise<any>=>{
    try{
      const response= await apiClient.get(
        `${ERMMEndPoint.TRACKING_LOG}${orderCode}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data
    }catch (error) {
      throw new Error(throwError(error));
    }
    // const res = await fetch(`http://127.0.0.1:3002/api/v1/orderhead/log/${orderCode}`);
    //   if (!res.ok) throw new Error("Failed to fetch log file");
    //   return res.text(); 
  },

  getProcessType: async (): Promise<
    IStandardResponse<Array<IProcessType>>
  > => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IProcessType>>
      >(ERMMEndPoint.PROCESS_TYPE);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },

  getYarnOrdersFcd: async (): Promise<
    IStandardResponse<Array<IFcdOrder>>
  > => {
    try {
      const { data } = await apiClient.get<
        IStandardResponse<Array<IFcdOrder>>
      >(ERMMEndPoint.ORDER_FCD);

      return data;
    } catch (error) {
      throw new Error(throwError(error));
    }
  },    
}